import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Form, Container, Button, Alert, Tabs, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import api from '../../api';
import firebase from "firebase";
// import styledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';
import ButtonLoader from '../../components/ButtonLoader';



// if (!firebase.apps.length) {
//     firebase.initializeApp({
//         apiKey: "AIzaSyDrpG7YDIJudmqQkE7t0XaYcSQgc8TPvwk",
//         authDomain: "skf-project.firebaseapp.com"
//     });
// } else {
//     firebase.app(); // if already initialized, use that one
// }


// firebase.initializeApp({
//     apiKey: "AIzaSyDrpG7YDIJudmqQkE7t0XaYcSQgc8TPvwk",
//     authDomain: "skf-project.firebaseapp.com"
// })

const Index = () => {
    const { isLogin, loginSuccess } = useContext(AuthContext);
    const [signIn, setsignIn] = useState(false);
    const [loginEmail, setloginEmail] = useState("");
    const [userId, setUserId] = useState("");
    const [alert, setAlert] = useState(false);

    const history = useHistory();

    const validSchema = Yup.object().shape({
        email: Yup.string().email().required("required"),
        password: Yup.string().required("required"),
        conPassword: Yup.string().oneOf([Yup.ref("password"), null], "Passwords must match")
    });

    const onSubmit = async (values) => {
        try {
            const res = await api.post("/auth/signup", {
                ...values,
                role: 'user',
                authSource: "email"
            });
            console.log("res", res);
            history.push('/');
        }

        catch (err) {
            setAlert(true)
            console.log("err", err);
        }
    }
    const uiConfig = {
        signInFlow: "popup",
        signInOptions: [
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.FacebookAuthProvider.PROVIDER_ID
        ],
        callbacks: {
            signInSuccess: async (currentUser, credential, redirectUrl) => {
                try {
                    console.log("current user s", currentUser.providerData[0].providerId)
                    // const userId = currentUser.uid;
                    const authSource = currentUser.providerData[0].providerId === "facebook.com" ? "facebook" : "google";
                    console.log("authsource", authSource)
                    const res = await api.post('/auth/social/', {
                        firstName: currentUser.displayName,
                        email: currentUser.email,
                        userId: currentUser.uid,
                        role: "user",
                        authSource: authSource
                    });
                    loginSuccess(res.data.token);
                    redirectUrl = history.push('/');
                    return false;
                } catch (err) {
                    setAlert(true)
                    console.log("err", err);
                }

            },
        }
    }

    // firebase.auth().onAuthStateChanged((user) => {
    //     console.log('user: ', user);

    //     if (user) {
    //         console.log("user", user.displayName, user.uid, user.email)
    //         console.log("request going")
    //         api.post('/auth/social', {
    //             firstName: user.displayName,
    //             email: user.email,
    //             userId: user.uid
    //         }).then((res) => {
    //             console.log(res)
    //         }).catch((err) => console.log(err))
    //     }
    // });

    return (
        <section className="section-signin">
            <Container >
                <div style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center"
                }}>
                    < h2 className="mb-3" >Create your Subka Faida Account</h2>
                    <p className="mb-3">Already member?<Link to="/signin">Login </Link>here</p>

                </div>
                {
                    alert ?
                        <Alert variant="danger" className="rounded text-center">User already exist with same email</Alert>
                        : ""
                }
                <Row>
                    <Col md={6} sm={12}>
                        <Formik
                            onSubmit={(values, formProps) => trackPromise(onSubmit(values, formProps), 'user-register')}
                            validationSchema={validSchema}
                            enableReinitialize
                            initialValues={{
                                email: '',
                                password: '',
                                conPassword: '',
                            }}
                        >
                            {(formik) => (
                                <Form onSubmit={formik.handleSubmit} id="user-register">
                                    <Form.Row>
                                        <Form.Group controlId="email" as={Col} hasValidation>
                                            <Form.Label className="form__label">Phone Number or Email</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                type="text"
                                                name="email"
                                                placeholder="Please Enter Your Phone Number or Email"
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.email && !formik.errors.email}
                                                isInvalid={formik.touched.email && formik.errors.email}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.email}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        {/* <Form.Group as={Col}>
                                            <Button className="section-signin__loginbutton button" type="submit">LOGIN</Button>
                                            <br />
                                            <span className="section-signin__loginLabel">Or, login with</span>
                                        </Form.Group> */}
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group controlId="password" as={Col} hasValidation>
                                            <Form.Label className="form__label">Password</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                type="password"
                                                name="password"
                                                placeholder="Please Enter Your Password"
                                                value={formik.values.password}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.password && !formik.errors.password}
                                                isInvalid={formik.touched.password && formik.errors.password}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.password}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        {/* <Form.Group as={Col}>
                                            <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
                                            <Button onClick={() => firebase.auth().signOut()}>Sign out</Button>
                                        </Form.Group> */}
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group controlId="conPassword" as={Col} hasValidation>
                                            <Form.Label className="form__label">Confirm Password</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                type="password"
                                                name="conPassword"
                                                placeholder="Please Enter Confirm Password"
                                                value={formik.values.conPassword}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.conPassword && !formik.errors.conPassword}
                                                isInvalid={formik.touched.conPassword && formik.errors.conPassword}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.conPassword}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        {/* <Form.Group as={Col}>
                                            <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
                                            <Button onClick={() => firebase.auth().signOut()}>Sign out</Button>
                                        </Form.Group> */}

                                    </Form.Row>
                                </Form>
                            )}
                        </Formik>
                    </Col>

                    <Col md={6} sm={12}>
                        {

                            <Button className="button section-signin__login-btn button btn-block rounded-0" type="submit" form="user-register">
                                <ButtonLoader trackerArea="user-register">
                                    Signup
                                </ButtonLoader>
                            </Button>
                        }
                        <p className="mt-1 mb-0">Or, signup with</p>
                        <StyledFirebaseAuth className="firebase-ui-cus" uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
                    </Col>
                </Row>
            </Container>
        </section >
    )
}

export default Index;
